import { RDCashCrop } from '@cibo/core'
import { CropChip, NotObservedChip, useFigures } from '@cibo/ui'
import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { DetailPanel } from '../DetailPanel'
import { CashCropPanelTable } from './CashCropPanelTable'

export const CashCropPanel = () => {
  const { t } = useTranslation('@cibo/landmanager/CashCropPanel')
  const { cropYieldPerAcre } = useFigures()

  return (
    <DetailPanel<RDCashCrop>
      title={t('cashCrop')}
      traitId="cashCrop"
      DetailTable={CashCropPanelTable}
      DetailIndividual={({ currentYearData }: { currentYearData?: RDCashCrop }) => (
        <>
          <Stack alignItems="center">
            {!!currentYearData?.result ? (
              <CropChip crop={currentYearData?.result} source={currentYearData.source} />
            ) : (
              <NotObservedChip />
            )}
          </Stack>
          <Stack>
            <Typography variant="subtitle1">
              {!!currentYearData?.input?.yieldPerAcre && !!currentYearData.result
                ? cropYieldPerAcre({
                    cropYield: currentYearData.input.yieldPerAcre,
                    crop: currentYearData.result,
                  })
                : '--'}
            </Typography>
          </Stack>
        </>
      )}
    />
  )
}
